import { render, staticRenderFns } from "./Calculation.vue?vue&type=template&id=512a778e"
import script from "./Calculation.vue?vue&type=script&lang=ts"
export * from "./Calculation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports